"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dropdown = require("./dropdown");
var _headerUtils = require("./headerUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Header = props => {
  const {
    headerInfo,
    t
  } = props;
  const [navVisible, setNavVisible] = (0, _react.useState)(false);
  const [dropdowns, setDropdowns] = (0, _react.useState)(new Array(headerInfo.dropdownCount).fill(false));
  const toggleNavigation = () => {
    setNavVisible(!navVisible);
  };
  const offNavigation = () => {
    setDropdowns(dropdowns.map(item => {
      item = false;
    }));
  };
  const toggleDropDown = index => {
    dropdowns[index] = !dropdowns[index];
  };
  const minWindowWidth = 800;
  const toggleMobileNav = () => {
    let currentWindowWidth = window.innerWidth;
    if (currentWindowWidth <= minWindowWidth) {
      setNavVisible(!navVisible);
    }
  };
  return /*#__PURE__*/_react.default.createElement("header", {
    className: "con-header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-header__inner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-heading__main"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "con-home-link",
    to: "/"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "con-visually-hidden"
  }, "".concat(headerInfo.logoAltText, " link to homepage")), /*#__PURE__*/_react.default.createElement("img", {
    className: "con-header__logo",
    src: headerInfo.logoUrl,
    alt: headerInfo.logoAltText
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-header__navigation"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "con-header__navigation--burger-icon",
    onClick: () => {
      toggleNavigation();
    }
  }), /*#__PURE__*/_react.default.createElement("nav", {
    className: "con-header__navigation".concat(navVisible ? '--visible' : '--hidden')
  }, headerInfo.headerList.map(item => {
    return item.headerType.toLowerCase() === "dropdown" ? /*#__PURE__*/_react.default.createElement(_dropdown.Dropdown, {
      dropdownList: item,
      offNavigation: offNavigation,
      bool: dropdowns[item.headerElement.id] === true,
      dropdowns: dropdowns,
      setDropdowns: setDropdowns,
      t: t,
      click: toggleDropDown
    }) : /*#__PURE__*/_react.default.createElement(_headerUtils.HeaderLink, {
      t: t,
      item: item,
      offNavigation: offNavigation,
      toggleMobileNav: toggleMobileNav
    });
  })))));
};
exports.Header = Header;
Header.propTypes = {
  headerInfo: _propTypes.default.shape({
    logoUrl: _propTypes.default.string,
    logoAltText: _propTypes.default.string,
    headerList: _propTypes.default.arrayOf(_propTypes.default.shape({
      headerType: _propTypes.default.string,
      headerElement: _propTypes.default.object
    }))
  })
};